const services = [
  "教材・出版プロジェクト",
  "新製品化プロジェクト",
  "健康事業プロジェクト",
  "サロン経営プロジェクト",
  "サロン経営コンサルティング",
  "学校・スクールコンサルティング",
  "スクール・セミナープロジェクト",
  "総合美容検定",
  "グローバルプロジェクト",
];

export default function AboutSection() {
  return (
    <section className="w-full bg-white scroll-mt-20" id="services">
      {/* Two Column Layout */}
      <div className="flex flex-col lg:flex-row min-h-[600px] md:min-h-[700px]">
        {/* Left Column - Photo */}
        <div className="w-full lg:w-1/2 relative min-h-[400px] lg:min-h-full">
          <img
            src="https://media.genaiweb.ai/73acebca-6391-4da3-b270-472de16380f3/8216d043.jpeg"
            alt="メイクアップ講座"
            className="absolute inset-0 w-full h-full object-cover"
          />
        </div>

        {/* Right Column - Content */}
        <div className="w-full lg:w-1/2 bg-gamo-light-gray flex flex-col justify-center py-12 md:py-16 lg:py-20 px-6 md:px-10 lg:px-16">
          <div className="mb-8">
            <span className="text-gamo-green text-xs block mb-2">● 事業内容</span>
            <h2 className="text-gamo-black text-2xl md:text-3xl font-light mb-4">
              群馬県高崎市を中心に、健康・美容の様々な課題を解決します。
            </h2>
            <p className="text-gamo-medium-gray text-sm leading-relaxed">
              群馬県高崎市を拠点とするTBM健康美容研究所は、健康・美容トレンドをプロデュースする総合美容を専門とする会社です。
              ヘアケアをはじめとする美容商材の開発・流通に加え、教材・出版、新製品化、健康事業、サロン経営、コンサルティング、スクール・セミナー、総合美容検定、グローバルプロジェクトなど、多角的な健康美容事業を展開しています。
            </p>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-gamo-black text-sm font-medium mb-4">主要事業プロジェクト</h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
              {services.map((service) => (
                <span
                  key={service}
                  className="flex items-center gap-2 text-sm text-gamo-dark-gray"
                >
                  <span className="w-2 h-2 rounded-full bg-gamo-green flex-shrink-0"></span>
                  <span>{service}</span>
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}